





























import Vue from 'vue'
import CheckCircle from '@/assets/svgs/check_circle.svg?inline'
import Button from '@/components/atoms/Button.vue'
import Input from '@/components/atoms/Input.vue'

interface Data {
  currentPassword: string
  newPassword: string
  passwordRequirements: {
    key: string
    label: string
  }[]
  newPasswordValid: boolean
}

interface Methods {
  save: () => void
  handleCancel: () => void
  checkValidity: () => void
}

interface Computed {
}

interface Props {}

const PASSWORD_REQUIREMENTS = [
  // Match key to i18n key
  {
    key: 'characterCount',
    regex: '.{8,}'
  },
  {
    key: 'uppercaseCount',
    regex: '.*[A-Z].*'
  },
  {
    key: 'numeralCount',
    regex: '.*\\d.*'
  },
  {
    key: 'specialCount',
    regex: '.*[!@#$%^&*].*'
  }
]

export default Vue.extend<Data, Methods, Computed, Props>({
  name: 'Security',
  data: function () {
    return ({
      currentPassword: '',
      newPassword: '',
      passwordRequirements: PASSWORD_REQUIREMENTS.map(req => ({
        key: req.key,
        label: this.$t(req.key) as string,
        regStr: req.regex
      })),
      newPasswordValid: false
    })
  },
  methods: {
    save: function () {
      // TODO: update password
    },
    handleCancel: function () {
      this.currentPassword = ''
      this.newPassword = ''
    },
    checkValidity: function () {
      this.$nextTick(() => { // Wait until next tick so ref is updated
        this.newPasswordValid = this.$refs.passwordForm ? (this.$refs.passwordForm as HTMLFormElement).checkValidity() : false
      })
    }
  },
  watch: {
    currentPassword: function () {
      this.checkValidity()
    },
    newPassword: function () {
      this.checkValidity()
    }
  },
  components: {
    CheckCircle,
    Button,
    'car-input': Input
  }
})
